<template>
  <div style="padding: 20px">
 
    <v-row justify="center">
      <v-col class="py-0" cols="12">
        <v-card>
          <v-toolbar
                primary-title
                class="white--text rounded-t"
                color="indigo"
                dense
              >
                <v-toolbar-title
                  >Anagrafiche
                  {{
                    tipo_anagrafiche_visualizzate == "C"
                      ? "Clienti"
                      : "Fornitori"
                  }}</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="mr-5"
                      @click="clicAkdd"
                      small
                    >
                      <v-icon color="primary"> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Nuova Anagrafica</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="mr-5"
                      @click="getAnagrafiche('C')"
                      small
                    >
                      <v-icon color="primary"> mdi-account </v-icon>
                    </v-btn>
                  </template>
                  <span>Anagrafica Clienti</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="getAnagrafiche('F')"
                      small
                    >
                      <v-icon color="primary"> mdi-truck </v-icon>
                    </v-btn>
                  </template>
                  <span>Anagrafica Fornitori</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <!-- Bottone di attivazione dei filtri -->
            <v-tooltip bottom v-if="filtri_visible === false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="filtri_visible = true"
                  small
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon color="purple lighten-2">mdi-filter</v-icon></v-btn
                >
              </template>
              <span>Filtri</span>
            </v-tooltip>

            <!-- Bottone di disattivazione dei filtri -->
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="ripristina"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="purple lighten-2">mdi-filter-off</v-icon>
                </v-btn>
              </template>
              <span>Ripristina</span>
            </v-tooltip>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="clickChiudi" small v-on="on" v-bind="attrs">
                      <v-icon color="error">mdi-keyboard-backspace</v-icon>
                    </v-btn>
                  </template>
                  <span>Indietro</span>
                </v-tooltip>
              </v-toolbar>
                 <!-- filtri -->
            <v-row v-if="filtri_visible == true" class="ma-2">
               <v-col>
              <v-autocomplete
                @change="filtra"
                dense
                hide-details
                :items="items_anagrafiche"
                :item-text="(item) => item.codice"
                :item-value="(item) => item.codice"
                label="Codice"
                style="display: inline-block; max-width: 350px"
                v-model="codice_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      codice_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      codice_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
               <v-col>
              <v-autocomplete
                @change="filtra"
                dense
                hide-details
                :items="items_anagrafiche"
                :item-text="(item) => item.ragione_sociale"
                :item-value="(item) => item.ragione_sociale"
                label="Ragione Sociale"
                style="display: inline-block; max-width: 350px"
                v-model="ragione_sociale_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      ragione_sociale_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      ragione_sociale_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
               <v-col>
              <v-autocomplete
                @change="filtra"
                dense
                hide-details
                :items="items_anagrafiche"
                :item-text="(item) => item.piva"
                :item-value="(item) => item.piva"
                label="Partita Iva"
                style="display: inline-block; max-width: 350px"
                v-model="partita_iva_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      partita_iva_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      partita_iva_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
            </v-row>
          <v-data-table
            :headers="headers_anagrafiche"
            :items="items_anagrafiche_visualizzate"
            class="elevation-1"
          >
            
            <!-- Bottone Stampa -->
            <template v-slot:[`item.dettagli`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="clickDettagli(item)"
                    small
                  >
                    <v-icon color="primary">mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Dettaglio Anagrafica</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="dettagli_anagrafica_visible" width="70%">
      <DettagliAnagrafica
        @aggiorna_anagrafica="aggiornaAnagrafica"
        @aggiungi_anagrafica="aggiungiAnagrafica"
        :anagrafica_sel="anagrafica_sel"
        @click_chiudi="dettagli_anagrafica_visible = false"
      />
    </v-dialog>
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import DettagliAnagrafica from "@/components/PRODUCTION/Anagrafiche/DettagliAnagrafica.vue";

export default {
  name: "Anagrafiche",
  components: {
    DettagliAnagrafica,
  },
  data() {
    return {
      // Variabili d'appoggio
      anagrafica_sel: null,
      tipo_anagrafiche_visualizzate: "",
      ragione_sociale_search: "",
      codice_search: "",
      partita_iva_search: "",

      // Modal
      caricamento_dati: false,
      dettagli_anagrafica_visible: false,
      filtri_visible: false,
      // Array
      headers_anagrafiche: [
        { text: "Codice", sortable: false, value: "codice" },
        { text: "Ragione Sociale", sortable: false, value: "ragione_sociale" },
        { text: "Indirizzo", sortable: false, value: "indirizzo" },
        { text: "CAP", sortable: false, value: "cap" },
        { text: "Località", sortable: false, value: "localita" },
        { text: "Provincia", sortable: false, value: "provincia" },
        { text: "Regione", sortable: false, value: "regione" },
        { text: "P. IVA", sortable: false, value: "piva" },
        { text: "Codice Fiscale", sortable: false, value: "cod_fiscale" },
        { text: "Telefono", sortable: false, value: "telefono" },
        { text: "Dettagli", sortable: false, value: "dettagli" },
      ],
      items_anagrafiche: [
        // {
        //   codice: 2023948,
        //   ragione_sociale: "Trattamenti termici srl",
        //   indirizzo: "Via Palestro 3",
        //   cap: 13039,
        //   localita: "Torino",
        //   provincia: "Torino",
        //   regione: "Piemonte",
        //   p_iva: "001212232",
        //   codice_fiscale: "00032929288",
        //   telefono: "011.373733",
        //   tipo: "C",
        //   dettagli: "asas",
        // },
        // {
        //   codice: 45435678,
        //   ragione_sociale: "Forniture meccaniche srl",
        //   indirizzo: "Via Minniti 7",
        //   cap: 46445,
        //   localita: "Novara",
        //   provincia: "Novara",
        //   regione: "Piemonte",
        //   p_iva: "0038476",
        //   codice_fiscale: "00032929288",
        //   telefono: "011.445468",
        //   tipo: "F",
        //   dettagli: "",
        // },
      ],
      items_anagrafiche_clienti: [],
      items_anagrafiche_fornitori: [],
      items_anagrafiche_visualizzate: [],
    };
  },
  methods: {
    aggiornaAnagrafica() {
      console.log("entrata risposta a evento aggiorna_anagrafica");
      this.dettagli_anagrafica_visible = false;
      this.getAnagrafiche(this.tipo_anagrafiche_visualizzate);
    },
    aggiungiAnagrafica(tipo_anagrafica_aggiunta) {
      // Nascondo il dialog dei dettagli anagrafica.
      this.dettagli_anagrafica_visible = false;

      /* Se ho aggiunto un'anagrafica dello stesso tipo di quelle
       * attualmente visualizzate, rifaccio la getAnagrafiche per
       * aggiornare i dati. Altrimenti tutto resta com'è. */
      if (this.tipo_anagrafiche_visualizzate == tipo_anagrafica_aggiunta) {
        this.getAnagrafiche(this.tipo_anagrafiche_visualizzate);
      }
    },
    clicAkdd() {
      this.dettagli_anagrafica_visible = true;
      this.anagrafica_sel = Object.assign(
        {},
        {
          id_anagrafica: -1,
          codice: null,
          ragione_sociale: "",
          indirizzo: "",
          cap: null,
          localita: "",
          provincia: "",
          regione: "",
          p_iva: "",
          codice_fiscale: "",
          telefono: "",
          tipo: "N",
          dettagli: "",
        }
      );
    },
    clickChiudi() {
      this.$router.push("/home/production");
    },
    clickDettagli(item) {
      this.anagrafica_sel = Object.assign({}, item);
      this.dettagli_anagrafica_visible = true;
    },
      filtra() {
      let items_ana_tmp = [];
      this.items_anagrafiche.forEach((elem) => {
        items_ana_tmp.push(elem);
      });
      // Filtro la ragione sociale
      if (this.ragione_sociale_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_ana_tmp.forEach((elem) => {
          if (elem.ragione_sociale == this.ragione_sociale_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_ana_tmp = res;
      }
      if (this.partita_iva_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_ana_tmp.forEach((elem) => {
          if (elem.piva == this.partita_iva_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_ana_tmp = res;
      }

      if (this.codice_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_ana_tmp.forEach((elem) => {
          if (elem.codice == this.codice_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_ana_tmp = res;
      }

      this.items_anagrafiche_visualizzate = [];
      this.items_anagrafiche_visualizzate = items_ana_tmp;
    },
    getAnagrafiche(parametro) {
      this.tipo_anagrafiche_visualizzate = parametro;

      /* Parametro "C" -> anagrafiche clienti,
       * parametro "F" -> anagrafiche fornitori. */
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getanagrafica",
          token: localStorage.getItem("user_token"),
          tipo: parametro,
          db_name: "quickproduction",
          id_utente: localStorage.getItem("id"),
        },
      };

      this.caricamento_dati = true;
      this.$store.dispatch("api", request).then((res) => {
        // Azzero le anagrafiche
        this.items_anagrafiche = [];

        // Popolo le anagrafiche in base alla response
        this.items_anagrafiche = res.data;
        this.items_anagrafiche_visualizzate = this.items_anagrafiche;
        this.caricamento_dati = false;
      });
    },
     ripristina() {
      // Rendo invisibili i filtri e resetto le chiavi di filtro
      this.partita_iva_search = "";
      this.ragione_sociale_search = "";
      this.codice_search = "";
      this.filtri_visible = false;

      // Resetto le commesse visualizzati in tabella
      this.items_anagrafiche_visualizzate = [];
      this.items_anagrafiche_visualizzate = this.items_anagrafiche;
    },
  },
  mounted() {
    this.getAnagrafiche("C");
  },
};
</script>
<style scoped>
</style>